module.exports = __webpack_public_path__ + "static/media/icon_cronologic.7ddc3dc3.svg";